import { useContext, useEffect, useState } from 'react';
import TEXTS from '../controller/TextVariables';
import Control from '../controller/Control';
import { renderToString } from 'react-dom/server';
import MapContext from '../controller/MapProvider';

const ZoomNumberControl = (props) => {
    const { zoomRead, map } = useContext(MapContext);
    const className = 'map-zoom-num';
    const [input, setInput] = useState(null);

    const sanitizeZoom = (z) => {
        let zoomStr = parseInt(z.replace(/[^0-9.]/g, ''));
        if (isNaN(zoomStr)) return '';
        return zoomStr;
    };
    const onInput = (e) => {
        let zoomStr = sanitizeZoom(e.target.value);
        if (zoomStr < 2) return;
        input.value = Math.floor(zoomStr);
        map.getView().setZoom(zoomStr * 1);
        // map.getView().dispatchEvent('change');
        // map.dispatchEvent('moveend');
    };
    const updateText = (z) => {
        if (!input) return;
        let zoomStr = sanitizeZoom(z);
        if (zoomStr < 2) return;
        input.value = Math.floor(zoomStr);
    };
    useEffect(() => updateText(zoomRead + ''), [zoomRead]);

    const controlAdded = (acontrol) => {
        const inp = acontrol.element.querySelector('input');
        if (input || inp) return;
        const inputSTR = renderToString(
            <a title={TEXTS.controls.zoom_level.tooltip}>
                <input aria-label={TEXTS.controls.zoom_level.tooltip} className={className} pattern="[0-9]+" required value={zoomRead} onChange={() => {}} />
            </a>
        );
        acontrol.element.innerHTML = inputSTR;
        setInput(acontrol.element.querySelector('input'));
    };
    useEffect(() => {
        if (!input) return;
        input.addEventListener('input', onInput);
        return () => {
            input.removeEventListener('input', onInput);
        };
    }, [input]);

    return <Control map={props.map} className={className} onMount={controlAdded}></Control>;
};
export default ZoomNumberControl;
